import {SEND_PHONE_NUMBER_SUCCESS} from "../../reducers/signinReducer";

export const submitPhoneSuccess = (authToken) =>{
    return {
        type: SEND_PHONE_NUMBER_SUCCESS,
        payload: {authToken, smsSent: true}
    }
}